// CMTAssignDialog.jsx
import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TransferList,
  Snackbar,
  Alert,
} from "@mui/material";
import axios from "axios";
import { useTheme } from "@mui/material/styles";
import { Box } from "@mui/system";
import TransferListComponent from "./TransferListComponent";
import { tokens } from "../../theme";

const CMTAssignDialog = ({
  open,
  onClose,
  assigned = [],
  available = [],
  onSave,
  compoundId,
}) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [left, setLeft] = useState([]);
  const [right, setRight] = useState([]);
  const [isSubmit, setIsSubmit] = useState(false);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  useEffect(() => {
    setLeft(available);
    setRight(assigned);
  }, [available, assigned]);

  const handleSubmit = async () => {
    if (!compoundId) {
      setSnackbar({
        open: true,
        message: "Compound ID is missing.",
        severity: "error",
      });
      return;
    }

    try {
      setIsSubmit(true);
      const payload = {
        compoundId,
        assignedCMTs: right.map((cmt) => cmt.id),
      };
      await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/api/admin/compound/update-cmts`,
        payload,
        { withCredentials: true }
      );
      setSnackbar({ open: true, message: "CMTs updated", severity: "success" });
      onSave?.();
      onClose();
    } catch {
      setSnackbar({
        open: true,
        message: "Failed to update CMTs",
        severity: "error",
      });
    } finally {
      setIsSubmit(false);
    }
  };

  return (
    <>
      <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
        <DialogTitle
          sx={{
            fontWeight: "bold",
            fontSize: "1.1rem",
            bgcolor: colors.primary[600],
            color: "#fff",
            py: 1.5,
            px: 3,
          }}
        >
          Assign Compound Management Team
        </DialogTitle>
        <DialogContent>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              mt: 2,
            }}
          >
            <TransferListComponent
              left={left}
              right={right}
              setLeft={setLeft}
              setRight={setRight}
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose}>Cancel</Button>
          <Button onClick={handleSubmit} variant="contained">
            Save
          </Button>
        </DialogActions>
      </Dialog>
      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
      >
        <Alert severity={snackbar.severity}>{snackbar.message}</Alert>
      </Snackbar>
    </>
  );
};

export default CMTAssignDialog;
